module.exports = __webpack_public_path__ + "img/papua-new-guinea.1738108c.svg";